import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import StitchingtaskDashboard from '../StitchingtaskDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import StitchingtaskPageImpl from './StitchingtaskPageImpl';

export default function StitchingtaskPage() {
    const dispatch = useDispatch();
    const { stitchingtaskList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < StitchingtaskPageImpl />
    )

}